import { SelectionModel } from "@angular/cdk/collections";
import { Component, EventEmitter, OnInit, ViewChild } from "@angular/core";
import {
  MatPaginator,
  MatSnackBar,
  MatTable,
  MatTableDataSource,
  PageEvent,
} from "@angular/material";
import { NavigationExtras, Router } from "@angular/router";
import { AuthService } from "src/app/auth/auth.service";
import { HealthOrganizationData } from "src/app/core/model/v2/practice/HealthOrganizationData";
import { HealthOrganizationSetupDomain } from "src/app/core/model/v2/practice/HealthOrganizationSetupDomain";
import { HealthSystemSetup } from "src/app/core/model/v2/practice/HealthSystemSetup";
import { CommonService } from "src/app/core/services/v2/common.service";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { UserService } from "src/app/core/services/v2/user.service";
import { SideBarInitializeParameters } from "src/app/shared/components/dynamic-right-sidebar/SideBarInitializeParameters";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { SetupOrganizationEditorComponent } from "../setup-organization/setup-organization-editor/setup-organization-editor.component";
import { SetupOrganizationFormComponent } from "../setup-organization/setup-organization-form/setup-organization-form.component";
import { SetupService } from "../setup.service";

@Component({
  selector: "app-setup-practice",
  templateUrl: "./setup-practice.component.html",
  styleUrls: ["./setup-practice.component.scss"],
})
export class SetupPracticeComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  healthOrganizationSetup: HealthOrganizationSetupDomain;
  healthSystems: HealthSystemSetup[];
  selection = new SelectionModel<HealthSystemSetup>(true, []);
  dataSource: MatTableDataSource<HealthSystemSetup>;
  selectedFile: [];

  displayedColumns: string[] = [
    "select",
    "name",
    "npi",
    "specialty",
    "specialization",
    "cityAndState",
    "PrimaryContact",
    // "type",
    // "address",
    "actions",
  ];
  pageLength = 10;
  pageIndex = 1;
  totalRecords: number;
  hoDto: HealthOrganizationData;
  disableNext: boolean = null;
  showActions: boolean;
  sectionName: string;
  sideBarHeader: string;
  toggleSidebar = false;
  selectedPractice: HealthSystemSetup;
  userDetails: any;

  constructor(
    private practiceService: PracticeService,
    private setupService: SetupService,
    private router: Router,
    private loaderService: WindowLoaderService,
    public authService: AuthService,
    private commonService: CommonService,
    private _snackBar: MatSnackBar,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.onCloseEditHOData.subscribe(() => {
      this.loadHealthOrganizatioData();
    });
    if (this.authService.isLoggedIn()) {
      this.loadData();
    }
  }
  
  ngAfterViewInit(){
    if (this.userService.userDetail$) {
      this.userService.userDetail$.subscribe(
        (userDetails) => {
          this.userDetails = userDetails;
        },
        (error) => { console.error(error); }
      );
    }
  }

  currentUserCanAddPractice(): boolean {
    var currentUser = this.practiceService.getCurrentUser();

    if (currentUser) {
      if (
        currentUser.healthOrganizationCreator ||
        currentUser.isGlobalAdministrator ||
        currentUser.role == "Administrator"
      )
        return true;
    }
    return false;
  }

  goNext(element?): void {
    const queryParams: any = {};
    let ids = [];
    if (element) {
      ids.push(element.id);
    } else if (this.selection.selected.length > 0) {
      ids = this.selection.selected.map((el) => {
        return el.id;
      });
    } else {
      ids.push(element.id);
    }
    queryParams.idsArray = JSON.stringify(ids);
    const navigationExtras: NavigationExtras = {
      queryParams,
    };

    if (this.healthSystems && this.healthSystems.length > 0) {
      this.router.navigate(["/physician/profile/summary"], navigationExtras);
    } else {
      this.disableNext = true;
      this._snackBar.open(
        "Please add at least one practice to your organization.",
        "Ok"
      );
    }
  }

  loadData(): void {
    this.loadHealthOrganizatioData();
    this.loaderService.show();
    this.practiceService.getHealthOrganizationDetailsByLoggedUser().subscribe(
      (data) => {
        this.healthOrganizationSetup = data;
        this.healthSystems = this.healthOrganizationSetup.healthSystems;
        this.dataSource = new MatTableDataSource(this.healthSystems);
        this.dataSource.paginator = this.paginator;
        this.totalRecords = this.healthSystems.length;
        if (this.healthSystems && this.healthSystems.length > 0) {
          this.masterToggle();
          this.selection.select(...this.healthSystems);
          this.isAllSelected();
        } else {
          this.totalRecords = 0;
        }
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  getType(element) {
    switch (element.practiceType) {
      case 0:
        return "Health";
      case 2:
        return "Legal";
      case 1:
        return "Case Management";
    }
  }

  private loadHealthOrganizatioData() {
    this.practiceService.getHealthOrganizationData().subscribe((value) => {
      if (value.resultStatus.isSuccess) {
        this.hoDto = value.result;

        if (
          !value.result.isProfileSetUpCompleted &&
          value.result.endOfTrialDate
        ) {
          if (new Date() > new Date(value.result.endOfTrialDate)) {
            this._snackBar.open(`Your Trial Period Has Expired`, "Ok");
          }
        }
      }
    });
  }

  toggleEditSidebar(header: string, item?: HealthSystemSetup) {
    if (header === "Add Practice Profile") {
      this.disableNext = null;
    }
    this.selectedPractice = item;
    this.sideBarHeader = header;
    this.toggleSidebar = !this.toggleSidebar;
    !this.toggleSidebar ? this.loadData() : null;
    this.showHideScroll(this.toggleSidebar);
  }

  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector("body");
    if (isOpen) {
      body.style.cssText = "height:100vh; overflow:hidden";
    } else {
      body.style.cssText = "height:auto; overflow:visible";
    }
  }

  deleteItemClick(item: HealthSystemSetup): void {
    if (this.selection.selected.length > 0) {
      let ids = this.selection.selected.map((el) => {
        return el.id;
      });
      this.practiceService.deleteHealthSystemById(item.id).subscribe(
        (_) => {
          this.loadData();
        },
        (error) => {
          console.error(error);
        }
      );
    }
    this.practiceService.deleteHealthSystemById(item.id).subscribe(
      (_) => {
        this.loadData();
      },
      (error) => {
        console.error(error);
      }
    );
  }

  redirectToProfile(hs: HealthSystemSetup) {
    if (hs.id > 0)
      if (this.healthOrganizationSetup.healthOrganizationTypeId == 2) {
        this.router.navigate(["/casemanager/profile/profilelocation/" + hs.id]);
      } else {
        this.router.navigate(["/practice/profile/profilelocation/" + hs.id]);
      }
  }

  onCloseEditHOData: EventEmitter<any> = new EventEmitter();

  editHealthOrganizationData() {
    const addPracticeManagerData = <SideBarInitializeParameters>{
      componentType: SetupOrganizationEditorComponent,
      data: this.hoDto,
      onClose: this.onCloseEditHOData,
    };
    this.commonService.rightSideBarComponent$.next(addPracticeManagerData);
  }

  getActions(i) {
    this.showActions = true;
  }

  getStaff(row) {
    this.showActions = false;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.healthSystems);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: HealthSystemSetup): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  isAllSelected() {
    let numRows;
    const numSelected = this.selection.selected.length;
    if (this.healthSystems) {
      numRows = this.healthSystems.length;
      return numSelected === numRows;
    }
  }
}
